import React, {useState} from "react";

const resolveObservedElement = (el) => {
    if (!el) {
        return null;
    }

    if (typeof el === "object" && "current" in el) {
        return el.current;
    }

    return el;
};

export default function useResizeObserver(el) {
    const [elementSize, setElementSize] = useState({});

    const observer = React.useRef(
        new ResizeObserver(entries => {
            const { width, height, bottom, top, left, right , x, y} = entries[0].contentRect;
            setElementSize({width : width, height : height, bottom: bottom, top: top, fullHeight: (bottom + top), fullWidth: (left + right), left: left, right: right, x: x, y: y});
        })
    );

    React.useEffect(() => {
        const observedElement = resolveObservedElement(el);
        if (!observedElement) {
            setElementSize({});
            return;
        }
        observer.current.observe(observedElement);

        return () => {
            observer.current.unobserve(observedElement);
        };
    }, [el, observer]);

    return elementSize;
}
